var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4883 6.89062C16.3681 8.55873 15.1307 9.84375 13.7812 9.84375C12.4318 9.84375 11.1923 8.55914 11.0742 6.89062C10.9512 5.15525 12.1558 3.9375 13.7812 3.9375C15.4067 3.9375 16.6113 5.18684 16.4883 6.89062Z",
    stroke: "#1A1919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 12.4688C11.1082 12.4688 8.53777 13.7964 7.89383 16.3821C7.80851 16.7241 8.02303 17.0625 8.37453 17.0625H19.1883C19.5398 17.0625 19.7531 16.7241 19.669 16.3821C19.0251 13.755 16.4546 12.4688 13.7812 12.4688Z",
    stroke: "#1A1919",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 7.62645C8.10714 8.95863 7.10718 10.0078 6.02929 10.0078C4.9514 10.0078 3.9498 8.95904 3.85546 7.62645C3.75744 6.24053 4.73074 5.25 6.02929 5.25C7.32785 5.25 8.30115 6.26596 8.20312 7.62645Z",
    stroke: "#1A1919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44931 12.5507C7.70898 12.2115 6.89359 12.0811 6.02939 12.0811C3.89658 12.0811 1.8417 13.1413 1.32695 15.2064C1.25928 15.4796 1.43072 15.7499 1.71127 15.7499H6.3165",
    stroke: "#1A1919",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.c18a9d5268fa3d68f781f718b93aeb0f.svg";
export { ForwardRef as ReactComponent };